module.exports = __webpack_public_path__ + "img/Efdot-Shirt-Blue-02.b5c8726b.jpg";